// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"0db627f6","197":"47919c9a","453":"c9fa93a2"}[chunkId] + ".chunk.js";
};